import React from "react";

const InputGroup = React.memo(
  ({id, type = "text", placeholder, value, onChange, onKeyDown, icon}) => (
    <div className="relative group w-full">
      <input
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        className={`w-full py-2 ${icon ? "pl-11" : "px-4"} pr-4 outline-none transition-all text-slate-800 placeholder:text-slate-400 font-[urbanist]`}
      />
    </div>
  ),
);

export default InputGroup;
